import { Box, Button, Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import Page from 'src/components/Page';
import { THEMES } from 'src/constants';

const ErrorView = ({ title, text }) => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('md'));

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  return (
    <Page
      sx={{
        backgroundColor: theme?.palette?.background?.dark || '#f6f8fb',
        minHeight: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: theme?.spacing ? theme.spacing(3) : 3,
        paddingTop: 10,
        paddingBottom: 10,
      }}
      title={title}
    >
      <Container maxWidth="lg">
        <Typography align="center" variant={mobileDevice ? 'h4' : 'h1'} color="textPrimary">
          {text}
        </Typography>
        <Box mt={6} display="flex" justifyContent="center">
          <Box
            component="img"
            alt="Under development"
            sx={{
              maxWidth: '100%',
              width: 560,
              maxHeight: 300,
              height: 'auto',
              filter: theme?.name === THEMES.LIGHT ? 'invert(.1)' : 'invert(.9)',
            }}
            src="/static/images/shopping_cart.svg"
          />
        </Box>
        <Box mt={6} display="flex" justifyContent="center">
          <Button color="secondary" onClick={handleBackToHome} variant="contained">
            Back to home
          </Button>
        </Box>
      </Container>
    </Page>
  );
};

export default ErrorView;
